import { render } from "./CustomerAddressList.vue?vue&type=template&id=5ca4f344"
import script from "./CustomerAddressList.vue?vue&type=script&lang=js"
export * from "./CustomerAddressList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/components/admin/customers/address/CustomerAddressList.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5ca4f344"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5ca4f344', __exports__)) {
    api.reload('5ca4f344', __exports__)
  }
  
  module.hot.accept("./CustomerAddressList.vue?vue&type=template&id=5ca4f344", () => {
    api.rerender('5ca4f344', render)
  })

}


export default __exports__